import React from 'react';
import classNames from 'classnames';
import update from 'immutability-helper';
import ReduxInfiniteScroll from 'redux-infinite-scroll';

import Card from 'components/Card';
import LoadingSpinner from 'components/LoadingSpinner';
import Modal from 'components/Modal';
import ModalButton from 'components/ModalButton';
import ModalHeader from 'components/ModalHeader';

export default class AssignmentPinpointsSelectionModal extends React.Component {
    _goBackToReviewModal(shouldReset) {
        if(shouldReset === true && this.oldBeacons != null) {
            this.props.handleChange(this.oldBeacons, 'beacons');
        }

        //Delete the temporary store oldGroup
        delete this.oldBeacons;

        this.props.openReviewModal();
    }

    _handleChange(beacon) {
        //copy old content to this.oldContent. If modal is cancelled, we'll copy it back
        if(this.oldBeacons == null) {
            this.oldBeacons = JSON.parse(JSON.stringify(this.props.assignment.beacons));
        }

        let beacons = update(this.props.assignment.beacons, {});
        let foundBeaconsIndex = -1;
        for(var i = 0, l = beacons.length; i < l; i++) {
            if(beacons[i].id === beacon.id) {
                foundBeaconsIndex = i;
                break;
            }
        }
        if(foundBeaconsIndex !== -1) {
            beacons.splice(foundBeaconsIndex, 1);
        } else {
            beacons.push(beacon);
        }

        this.props.handleChange(beacons, 'beacons');
    }

    _beaconIsSelected(beaconId) {
        let { assignment } = this.props;
        let found = false;
        for(var i = 0, l = assignment.beacons.length; i < l; i++) {
            if(assignment.beacons[i].id === beaconId) {
                found = true;
                break;
            }
        }

        return found;
    }


    render() {
        let { closeModal, pinpoints, show } = this.props;

        return (
            <Modal show={show}
                   className="assignment-pinpoints-selection assignment-selection item-selection"
                   handleClose={closeModal.bind(this)}
                   width="full">
                <ModalHeader>
                    Select PinPoints
                </ModalHeader>
                <ReduxInfiniteScroll className="assignment-selection__scroll"
                                     hasMore={pinpoints.hasMore}
                                     loadMore={this.props.loadMore.bind(this)}
                                     loadingMore={pinpoints.isFetching === true}
                                     loader={<LoadingSpinner />}>
                    <div className="cards">
                        {pinpoints.allPinpoints.map((pinpoint) => {
                            return (
                                <Card className={classNames({'selected': this._beaconIsSelected(pinpoint.id)})}
                                      item={pinpoint}
                                      onClick={this._handleChange.bind(this, pinpoint)}
                                      type="beacon--selection"
                                      key={pinpoint.id} />
                            );
                        })}
                        <div className="card empty"></div>
                        <div className="card empty"></div>
                        <div className="card empty"></div>
                    </div>
                    {pinpoints.hasMore === false ? (
                        <div className="cards__no-more">
                            No more content to load.
                        </div>
                    ) : null}
                </ReduxInfiniteScroll>
                <div className="modal__buttons">
                    <ModalButton icon="check"
                                 onClick={this._goBackToReviewModal.bind(this, false)}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 icon="cancel"
                                 onClick={this._goBackToReviewModal.bind(this, true)}
                                 text="Cancel" />
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentPinpointsSelectionModal.js